document.addEventListener('DOMContentLoaded', function() {
  const loadbeeObserver = new MutationObserver((mutations) => {
    $("#loadbee-section").show();
    $("#flixmedia-content").hide();
    $("#cnet-content").hide();
    document.getElementById('collapseFour').classList.remove('loading');
    document.querySelector('#page-characs-box').classList.remove("hidden");
    document.querySelector('.js-product-description-nav-item[data-tab-id="page-characs-box"]').classList.remove("hidden");
    document.querySelector('.js-sticky-product-description-nav-item[data-tab-id="page-characs-box"]').classList.remove("hidden");
  });
  
  loadbeeObserver.observe(document.querySelector(".loadbeeTabContent"), { subtree: true, childList: true });
});
